<template>
    <transition name="fade" mode="out-in">
        <section class="padding-vertical-content" key="paso2" id="paso2">
            <div class="container">
                <SeleccionarButacasComponent
                    :pack="pack"
                    :zona="zona"
                    :disabled="disabled"
                    :sesiones_ids="sesiones_ids"
                    @terminado="bloquearAsientos"
                />
            </div>
        </section>
    </transition>
</template>

<script>
import SeleccionarButacasComponent from "@/components/frontend/packs/venta/con_recinto/components/SeleccionarButacasComponent.vue";

export default {
    props: {
        zona: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        },
        pack: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            asientos_maximos: 5,
            asientos_minimos: 1,
            n_entradas: 0,
            loading: false
        }
    },
    mounted() {
        this.$scrollTo('#paso2', 100);
    },
    methods: {
        bloquearAsientos(asientos) {
            this.loading = true;
            var params = {
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                zona_id: this.zona.id,
                slug: this.pack.slug,
                asientos: asientos,
                sesiones_ids: this.sesiones_ids
            }

            this.$store.dispatch(this.config.getVuexAlias("front.packs.show.zonas.show.asientos.bloquear"), params).then(res => {
                this.$emit('continuar', asientos, res.data.session_id);
                this.loading = false;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
                this.loading = false;
            });
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        sesiones_ids() {
            const ids = [];
            this.pack.sesiones.forEach(sesion => {
                ids.push(sesion.id);
            })
            return ids;
        }
    },
    components: {
        SeleccionarButacasComponent
    }
}
</script>